import React from "react";
import { APP_BASE_PATH } from "../appConfig";
import { Box, Image, Text } from "@chakra-ui/react";

export const ImageItemNode = (props) => {
  let altText = props.altText;
  let title = props.title;

  if (props.altText && !props.title) {
    // If there is alt text and there is not an image title, set the image title to the alt text.
    title = props.altText;
  } else if (props.title && !props.altText) {
    // If there is an image title and there is not alt text, set the alt text to the image title.
    altText = props.title;
  }

  const src = `${APP_BASE_PATH}/Instruction/${props.instructionKey}/Artifact/?id=${props.file}`;
  const imageTitleSegment = title ? <Text as="i">{title}</Text> : "";

  return (
    <Box>
      <Image src={src} alt={altText} title={title} ignoreFallback />
      {imageTitleSegment}
    </Box>
  );
};
